export default function processVaccinationChartData(vaccinationChart) {
  if (!Array.isArray(vaccinationChart)) {
    return [];
  }

  const processedChart = vaccinationChart.map((ageGroup) => {
    const processedVaccines = ageGroup.vaccines 
      ? ageGroup.vaccines.map((vaccine) => ({
          id: vaccine.id,
          vaccineCd: null, // Not in original data but you might add it
          name: vaccine.vaccine_name,
          doseInfo: vaccine.dose_info,
          isMandatory: vaccine.mandatory,
          remarks: vaccine.remarks || '',
          nextDoseDate: vaccine.nextdosagedate,
          vaccinatedDate: vaccine.vaccinateddate,
          ageRange: vaccine.age_range,
          ageInDays: vaccine.age_in_days,
          // Add any additional processing here
          isActive: true // Assuming all in chart are active
        }))
      : null;

    return {
      ageRange: ageGroup.age_range,
      ageInDays: ageGroup.age_in_days,
      vaccines: processedVaccines,
      hasVaccines: !!ageGroup.vaccines // Helper field
    };
  });

  // You might want to sort by ageInDays if not already sorted
  processedChart.sort((a, b) => a.ageInDays - b.ageInDays);

  return processedChart;
}